import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'pk-broker-page-warnings',
	templateUrl: './page-warnings.component.html',
	styleUrls: ['./page-warnings.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PageWarningsComponent {
	@Input() warnings: string[];
}
